import { useFxRate } from '@mechhive/react';
import type { ChangeEvent } from 'react';
import { useState } from 'react';
import { useTranslate } from '~/hooks/useTranslate';
import { InputAmountSelect } from '../form/InputAmountSelect';
import { InputSelect } from '../form/InputSelect';
import { Price } from '../Price';

type product = {
  currency: string;
  feeCurrency: string;
  feeFixed: number;
  feeVariable: number;
  minAmount: number;
  maxAmount: number;
};

type FeeCalculatorProps = {
  products: Array<product>;
  fxRate: Array<{ from: string; to: string; rate: number; }>;
}

export const FeeCalculator = ( { products = []  , fxRate }: FeeCalculatorProps ) => {
  const t = useTranslate();
  const { convertCurrency } = useFxRate( fxRate );

  const [selectedProduct, setSelectedProduct] = useState( products[0] );

  const fixedFee = selectedProduct.feeCurrency !== selectedProduct.currency ? convertCurrency( selectedProduct.feeCurrency, selectedProduct.currency, selectedProduct.feeFixed ) :  selectedProduct.feeFixed;
  
  const [ amount, setAmount ] = useState( 20 );
  const [ receiveAmount, setReceiveAmount ] = useState( Math.max( amount - ( amount * ( selectedProduct.feeVariable / 100 ) + fixedFee ), 0 ) );

  const productCurrencies = products.map( p => ( {
    label: p.currency.toUpperCase(),
    value: p.currency
  } ) );

  const calculateFromAmount = ( amount: number ) => {
    const receiveAmount = Number( Math.max( amount - ( amount * ( selectedProduct.feeVariable / 100 ) + fixedFee ), 0 ) ).toFixed( 2 )

    setReceiveAmount( Number( receiveAmount ) );
    setAmount( amount );
  }

  const calculateFromReceive = ( amount: number ) => {
    const originalAmount = Number( ( amount + ( selectedProduct.feeVariable / 100 ) * amount ) + fixedFee ).toFixed( 2 );

    setReceiveAmount( amount );
    setAmount( Number( originalAmount ) );
  }


  const handleAmountChange = ( e: ChangeEvent<HTMLInputElement> ) => {
    calculateFromAmount( Number( e.target.valueAsNumber.toFixed( 2 ) )  )
  }

  const handleReceiveAmountChange = ( e: ChangeEvent<HTMLInputElement> ) => {
    calculateFromReceive( Number( e.target.valueAsNumber.toFixed( 2 ) ) );
  }

  return (
    <div className="p-10 bg-slate-900 bg-opacity-10 rounded-lg border-2 border-white border-opacity-20 flex flex-col lg:flex-row gap-10 lg:gap-16 justify-around ">
      <div className='w-full lg:w-56'>
        <InputAmountSelect
          title={ t( 'FEE_CALCULATOR_AMOUNT' ) }
          currency={ selectedProduct.currency }
          onChange={ handleAmountChange }
          value={ amount } 
          max={ selectedProduct.maxAmount }
          min={ selectedProduct.minAmount }/>
      </div>
      <div className='w-full lg:w-32'>
        <InputSelect
          title={ t( 'FEE_CALCULATOR_CURRENCY' ) }
          onChange={ ( value ) => setSelectedProduct( products.find( p => p.currency === value ) ?? products[0] ) }
          value={ selectedProduct.currency }
          options={ productCurrencies } />
      </div>
      <div className='flex flex-col gap-3 text-start'>
        <div className='font-semibold'>{t( 'FEE_CALCULATOR_FEES' )}</div>
        <div className='my-3.5 text-start text-white tabular-nums'>
          <Price currency={ selectedProduct.currency }>{fixedFee}</Price>       
          { ` +${selectedProduct.feeVariable ? selectedProduct.feeVariable : 0}%` } 
        </div>
      </div>
      <div className='w-full lg:w-56'>
        <InputAmountSelect
          title={ t( 'FEE_CALCULATOR_RECEIVE' ) }
          currency={ selectedProduct.currency }
          onChange={ handleReceiveAmountChange }
          value={ receiveAmount } 
          max={ selectedProduct.maxAmount }
          min={ selectedProduct.minAmount }/>
      </div>
    </div>
  )
}